import { Application } from "stimulus"
import { definitions } from "stimulus:."

const application = Application.start()
application.load(definitions)

// Configure Stimulus development experience
application.warnings = true
application.debug = true
window.Stimulus = application

export { application }
